module.exports = __webpack_public_path__ + "img/Citi.a172f532.svg";